/* ===========================================
   TRY AMIE HOMEPAGE SCRIPTS
   =========================================== */

document.addEventListener('DOMContentLoaded', function() {

  // FAQ Accordion
  const faqItems = document.querySelectorAll('.hp-faq__item');
  faqItems.forEach(item => {
    const question = item.querySelector('.hp-faq__question');
    if (question) {
      question.addEventListener('click', () => {
        // Close other items
        faqItems.forEach(other => {
          if (other !== item) {
            other.classList.remove('is-open');
          }
        });
        // Toggle current
        item.classList.toggle('is-open');
      });
    }
  });

  // Rotating headline (if present)
  const rotatingText = document.querySelector('.hp-hero__headline-rotating');
  if (rotatingText && rotatingText.dataset.words) {
    const words = JSON.parse(rotatingText.dataset.words);
    let currentIndex = 0;

    setInterval(() => {
      currentIndex = (currentIndex + 1) % words.length;
      rotatingText.style.opacity = 0;
      setTimeout(() => {
        rotatingText.textContent = words[currentIndex];
        rotatingText.style.opacity = 1;
      }, 300);
    }, 3000);
  }

});
